function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x34_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44494F"
    },
    d: "M512,16.015v406.666H0.239V65.175H0V19.52h0.478C0.16,18.406,0,17.209,0,16.015 C0,7.17,7.171,0,16.015,0h479.97C504.829,0,512,7.17,512,16.015z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.269,
    y: 62.678,
    style: {
      fill: "#FFFFFF"
    },
    width: 493.462,
    height: 349.392
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.269,
    y: 62.678,
    style: {
      opacity: 0.06,
      fill: "#0D0D0D"
    },
    width: 493.462,
    height: 20.763
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7BFA1"
    },
    points: "462.397,115.971 462.397,178.019 420.747,178.019 379.338,216.11 311.44,153.665  273.396,188.647 237.87,188.647 237.87,115.971  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F29B84"
    },
    points: "462.397,178.019 462.397,247.189 237.87,247.189 237.87,188.647 273.396,188.647  311.44,153.665 379.338,216.11 420.747,178.019  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9F8C9"
    },
    points: "462.397,174.365 462.397,182.337 422.755,182.337 379.423,222.075 311.326,159.631  274.966,192.965 237.87,192.965 237.87,184.994 271.36,184.994 311.326,148.364 379.423,210.808 419.149,174.365  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FEFDF0"
    },
    cx: 312.427,
    cy: 156.878,
    rx: 7.995,
    ry: 7.807
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FEFDF0"
    },
    cx: 420.747,
    cy: 178.019,
    rx: 7.995,
    ry: 7.807
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FEFDF0"
    },
    cx: 379.251,
    cy: 215.814,
    rx: 7.995,
    ry: 7.807
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FEFDF0"
    },
    cx: 274.243,
    cy: 186.484,
    rx: 7.995,
    ry: 7.807
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#8BC66F"
    },
    cx: 125.815,
    cy: 32.559,
    rx: 12.141,
    ry: 12.923
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F4DB6D"
    },
    cx: 81.65,
    cy: 32.559,
    rx: 12.141,
    ry: 12.923
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E06276"
    },
    cx: 37.485,
    cy: 32.559,
    rx: 12.141,
    ry: 12.923
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.699,
    y: 305.567,
    style: {
      opacity: 0.5,
      fill: "#899C99"
    },
    width: 76.66,
    height: 64.006
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.537,
    y: 356.288,
    style: {
      fill: "#899C99"
    },
    width: 51.228,
    height: 8.816
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.537,
    y: 308.167,
    style: {
      fill: "#899C99"
    },
    width: 105.815,
    height: 9.216
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.537,
    y: 332.127,
    style: {
      fill: "#899C99"
    },
    width: 105.815,
    height: 9.216
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 271.77,
    y: 305.567,
    style: {
      opacity: 0.5,
      fill: "#899C99"
    },
    width: 76.66,
    height: 64.006
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.607,
    y: 356.288,
    style: {
      fill: "#899C99"
    },
    width: 51.228,
    height: 8.816
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.607,
    y: 308.167,
    style: {
      fill: "#899C99"
    },
    width: 105.815,
    height: 9.216
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.607,
    y: 332.127,
    style: {
      fill: "#899C99"
    },
    width: 105.815,
    height: 9.216
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29640"
    },
    d: "M206.196,171.055c-3.329-14.232-10.237-27.39-19.96-38.229 c-9.73-10.846-22.283-19.363-36.956-24.252c-1.514-0.505-3.046-0.978-4.604-1.404c-13.785-3.769-27.696-3.962-40.773-1.183 c-15.467,3.287-29.758,10.751-41.264,21.503l63.837,64.49l78.9,21.573C209.31,199.163,209.372,184.628,206.196,171.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EA76"
    },
    d: "M205.375,213.554c3.935-14.391,3.996-28.926,0.821-42.499l-79.721,20.927l57.984,58.577 C194.098,240.489,201.44,227.945,205.375,213.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6992A1"
    },
    d: "M98.992,274.254c-13.645-3.731-25.617-10.54-35.395-19.455c-0.11-0.085-0.206-0.178-0.303-0.271 c-11.651-10.701-20.154-24.399-24.59-39.512c-4.359-14.87-4.799-31.097-0.411-47.145c4.388-16.048,13.023-29.793,24.341-40.377 l63.841,64.488l-22.805,83.408C102.111,275.051,100.55,274.68,98.992,274.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BCAD4"
    },
    d: "M103.67,275.389c15.116,3.257,30.262,2.31,44.152-2.073c0.123-0.044,0.256-0.085,0.379-0.129 c13.74-4.401,26.239-12.169,36.26-22.631l-57.682-58.27l-0.067-0.24l-0.09,0.086l-0.147-0.151l-0.113,0.413l-62.765,62.406 c9.778,8.914,21.75,15.724,35.395,19.455C100.55,274.68,102.111,275.051,103.67,275.389z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 429.489,
    y: 256.97,
    style: {
      fill: "#82CCD3"
    },
    width: 32.908,
    height: 20.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.246,
    y: 256.97,
    style: {
      fill: "#E4E78E"
    },
    width: 32.908,
    height: 20.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.004,
    y: 256.97,
    style: {
      fill: "#E5A871"
    },
    width: 32.908,
    height: 20.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.761,
    y: 256.97,
    style: {
      fill: "#6992A1"
    },
    width: 32.908,
    height: 20.313
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.3b3fda4ca355e46bde13fc1dcd7e41f5.svg";
export { ForwardRef as ReactComponent };